export default class SingleChoiceData {
    /**
     * 
     * @param {string} dialogId 
     * @param {string} situationId 
     * @param {string} optionId 
     * @param {string} skill 
     * @param {string} behaviour 
     * @param {number} timeToAnswer - in msecs 
     */
    constructor(episodeId, dialogId, situationId, optionId, skill, behaviour, timeToAnswer) {
        this.episodeId = episodeId;
        this.dialogId = dialogId;
        this.situationId = situationId;
        this.optionId = optionId;
        this.skill = skill;
        this.behaviour = behaviour;
        this.timeToAnswer = timeToAnswer;
    }
}
